import { render, staticRenderFns } from "./PleitoCronogramasFisicos.vue?vue&type=template&id=0273e789"
import script from "./PleitoCronogramasFisicos.vue?vue&type=script&lang=js"
export * from "./PleitoCronogramasFisicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports